import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

export const HeaderSlice = createSlice({
    name: "headerslice",
    initialState: {
        appRefreshedOn:'',
        appId:33,
        message:'',
        notification:'',
        isLoggedIn:false,
        appuserInfo:{},
        userprofileInfo:{
            rolename:'OPS_ANONYMOUS'
        },
        refreshUserProfile:false,
        profile:{},
        exchange : [],
        apiInProgress: false,
        initialAPIload:true,
        
        login:{
            loginModalOpen:false
        },
        showProfileMgmtModal:false,
        selectedItemList: [],
        myBusinessUserList:[],
        headerMessage:'',
    },
    reducers: {
        setMessage: (state, action) =>{
            state.message=action.payload;
        },
        setLoggedIn: (state, action) =>{
            state.isLoggedIn=action.payload;
        },
        setAppuserInfo: (state, action) =>{
            state.appuserInfo=action.payload;
        },
        setAppId: (state, action) =>{
            state.appId= action.payload;
        },
        setProfile : (state, action) =>{
            state.profile = action.payload;
        },
        setuserprofileInfo: (state, action) =>{
            state.userprofileInfo = action.payload;
        },
        logout: (state, action)=>{
            state.appuserInfo={};
            state.userprofileInfo={};
            Cookies.remove("anonymousId");
            state.isLoggedIn=false;
            localStorage.removeItem("JWT");
        },
        addInfo : (state, action)=>{
            let info = {id:action.payload.id, value:action.payload.value};
            state.exchange.push(info);
        },
        deleteInfo : (state, action)=>{
            let index = state.exchange.findIndex(a => a.id === action.payload)
            if (index>-1){
                console.log('GOT info object...>>>>>>');
                state.exchange.splice(index , 1);
            }
               
        },
        getInfo : (state, action)=>{
            let index = state.exchange.map(obj=>obj.id).indexOf(action.payload.id);
            if (index>-1){
                return state.exchange[index]
            }
            return null;
        },
        setApiInProgress: (state, action)=>{
            state.apiInProgress=action.payload;
        },
        setInitialAPIload: (state, action)=>{
            state.initialAPIload=action.payload;
        },
        setProduct: (state, action)=>{
            state.cart.selectedProduct=action.payload;
        },
        setProductColor: (state, action)=>{
            state.cart.selectedProduct.colorid=action.payload;
        },
        openLoginModal:(state,action)=>{
            state.login.loginModalOpen=action.payload;
        },
        setShowProfileMgmtModal: (state,action)=>{
            state.showProfileMgmtModal = action.payload;
        },
        refreshUserProfile: (state, action)=>{
            state.refreshUserProfile=!state.refreshUserProfile;
        },
        setSelectedItemList: (state, action) => {
            state.selectedItemList = [...state.selectedItemList, action.payload]; // Append new items
        },
        deleteItem: (state, action) => {
            state.selectedItemList = state.selectedItemList.filter(id => id !== action.payload);
        },
        resetSelectedItemList: (state) => {
            state.selectedItemList = []; // Reset the list to empty
        },
        showNotification: (state, action) => {       
            state.notification = action.payload;
        },
        setMyBusinessUserList: (state, action) => {
            state.myBusinessUserList = action.payload; // Set the list of business users
        },
        setHeaderMessage: (state, action) => {
            state.headerMessage = action.payload; // Set the header message
        },
        setappRefreshedOn: (state, action) => {
            state.appRefreshedOn = action.payload; // Set the app refreshed on timestamp
        }
    }
});
export const {setappRefreshedOn, setHeaderMessage, setMyBusinessUserList,showNotification, setSelectedItemList, deleteItem, resetSelectedItemList, refreshUserProfile,setShowProfileMgmtModal, openLoginModal, refreshOrder, refreshCart, setAnonymousId, setCartId, setCartCount,setProduct,setProductColor,setMessage, setLoggedIn, setAppuserInfo, setAppId, setProfile, setuserprofileInfo,logout, addInfo, deleteInfo,getInfo, setApiInProgress,setInitialAPIload} = HeaderSlice.actions;
export default HeaderSlice.reducer;